import axios from 'axios'



const api = axios.create({
    //baseURL: 'https://api.hospitaissaudaveis.org/',
    //baseURL: 'http://172.16.1.253:3700',
    baseURL: process.env.REACT_APP_API,
    
    headers: {
        'Content-Type': 'application/json',
        //'x-access-token': Buffer.from(process.env.REACT_APP_API_KEY).toString('base64')
        'x-access-token': process.env.REACT_APP_API_KEY,
    }
    
})

export default api  
